import { Uuid } from "../../domain/model/uuid/uuid.type";
import { IdNameBaseViewModel } from "./id-name-base.viewmodel";

export class GroupViewModel extends IdNameBaseViewModel {
  constructor(
    id: Uuid,
    name: string,
    readonly number: number) {
      super(id, name);
  }

  override toString(): string {
    return `Id: ${this.id}, Name: ${this.name}, Number: ${this.number}`;
  }
}